// ── 모바일 폭인가 (2026-09-14) ───────────────────────────────────────────────
// 같은 코드가 화면마다 복붙돼 있었다(quotemgmt·situationboard·tmsummary 3벌).
// 새로 쓰는 곳은 이걸 쓴다. 옛 사본 3개 정리는 별건.
//
// 기준 768px — 관리자 화면들이 쓰던 값 그대로다.

import { useEffect, useState } from 'react';

export const MOBILE_BREAKPOINT = 768;

export function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = useState(
    () => (typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false),
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
